import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import useDeeplinkRedirect from "../hooks/useDeeplinkRedirect";
import DeeplinkRedirect from "../components/mobile-app/DeeplinkRedirect";

export default function OAuthRedirect() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading"
  );
  const [message, setMessage] = useState("");
  const code = searchParams.get("code");
  const state = searchParams.get("state");

  useDeeplinkRedirect({
    path: "auth/login",
    query: { code, state },
    onMount: async () => {
      if (!code || !state) {
        throw new Error(
          "Missing required authentication parameters. Please try again."
        );
      }
      setStatus("loading");
      setMessage("Please wait while we authenticate your session...");
    },
    beforeRedirect: async () => {
      setStatus("success");
      setMessage("Authentication successful! Redirecting...");
    },
    onError: async (e: Error) => {
      setStatus("error");
      setMessage(
        e.message ||
          "An error occurred during authentication. Please try again."
      );
    },
  });

  return <DeeplinkRedirect status={status} message={message} />;
}
